const logOut = () => {
  localStorage.clear();
  window.location.href = '/login';
}

const getUser = () => {
  const user = localStorage.getItem('user');
  if (user) {
    return JSON.parse(user);
  }
  return null;
}

export {
  logOut,
  getUser,
}
